import React from "react";
import {Link} from "react-router-dom";

//import assets
import "../../assets/styles/headerStyles/headerLogo.scss";
import { AppLogo } from "../../assets/images";


export function HeaderLogo() {
    return <Link to={'/posts'} className="header-logo">
        <AppLogo/>
        {/*<div className="brand-name">Shat.am</div>*/}
    </Link>
}
